import './instrument';
import './index.scss';
import '@repo/styles/src/index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';

import BaseApp from './BaseApp';

// Enabling Strict Mode as it helps in easy migration to RC19
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BaseApp />
  </React.StrictMode>,
);
